import useTranslation from '@/hooks/i18n';

import { PodcastEntity, PodcastPage, ResponseCollectionMeta } from '@/graphql/generated/graphql';
import { create } from 'zustand';
import { fetchPodcastPage, fetchPodcastPageable } from '@/services/podcast/podcast.service';

type PodcastStore = {
  loading: boolean;
  page: { page: PodcastPage | null };
  podcasts: PodcastEntity[];
  latestPodcastEpisodes: PodcastEntity[];
  podcastsMeta: ResponseCollectionMeta | null;
  onChangePage: (page: number) => Promise<void>;
  onInit: () => Promise<void>;
  t: (value: string) => string;
};

export const usePodcastStore = create<PodcastStore>()((set) => ({
  loading: true,
  page: { page: null },
  podcasts: [],
  latestPodcastEpisodes: [],
  podcastsMeta: null,
  highlight: {},
  t: useTranslation().t,
  onInit: async () => {
    set({ loading: true });
    const page = await fetchPodcastPage();

    if (!page?.page?.topics?.data) {
      throw new Error('Failed to fetch topics');
    }

    const { podcasts, meta } = await fetchPodcastPageable(1);

    set({
      page,
      latestPodcastEpisodes: podcasts?.slice(0, 2) as PodcastEntity[],
      podcasts: podcasts as PodcastEntity[],
      podcastsMeta: meta as ResponseCollectionMeta,
      loading: false,
    });
  },
  onChangePage: async (page: number) => {
    const { podcasts, meta } = await fetchPodcastPageable(page);

    set({
      podcasts: podcasts as PodcastEntity[],
      podcastsMeta: meta as ResponseCollectionMeta,
    });
  },
}));
